// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.product-modal {
  .modal-overlay {
    position: fixed;
    inset: 0;
    background: rgba(30, 32, 38, 0.45);
    z-index: 1200;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px;
  }

  .modal-content {
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 6px 36px rgba(60, 72, 100, 0.18);
    width: 700px;
    max-width: 90vw;
    max-height: 85vh;
    display: flex;
    flex-direction: column;
  }

  .modal-close {
    position: absolute;
    top: 10px;
    right: 12px;
    font-size: 1.6rem;
    color: #444;
    cursor: pointer;
    z-index: 10;
  }

  .modal-body {
    display: flex;
    flex-direction: row;
    width: 100%;
    min-height: 0; /* Crucial for flex scrolling */
    height: 100%;
  }

  /* Left side: Image (Fixed) */
  .modal-image-col {
    flex: 0 0 300px;
    background: #f9f9fb;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px;
    min-height: 0;
  }


  /* Right side: Form Content (Scrollable) */
  .modal-form-col {
    flex: 1 1;
    padding: 16px;
    overflow-y: auto;
    min-height: 0;
    display: flex;
    flex-direction: column;
  }

  /* Custom scrollbar */
  .modal-form-col::-webkit-scrollbar {
    width: 6px;
  }
  .modal-form-col::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 3px;
  }

  .modal-title {
    font-size: 1.05rem;
    font-weight: 700;
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 4px;
  }

  .modal-name {
    color: #23213b;
    font-size: 1.05rem;
  }

  .modal-sku {
    color: #8882f6;
    font-size: 0.85rem;
    margin-left: 6px;
  }

  .modal-form {
    display: flex;
    flex-direction: column;
    gap: 8px;
    flex: 1 1;
  }

  .modal-label {
    font-size: 0.85rem;
    font-weight: 600;
    color: #444;
    margin-bottom: 4px;
  }

  .form-control,
  .form-select {
    font-size: 0.75rem;
  }

  .btn-sm {
    font-size: 0.7rem;
    padding: 5px 10px;
  }

  /* Responsive adjustments */
  @media (min-width: 1024px) {
    .modal-content {
      width: 850px;
    }
  }
  
  @media (max-width: 768px) {
    .modal-content {
      max-width: 95vw;
      max-height: 90vh;
    }

    .modal-body {
      flex-direction: column;
    }

    .modal-image-col {
      flex: 0 0 300px;
    }

    .modal-image {
      min-width: 180px;
      min-height: 180px;
    }
  }

  @media (max-width: 480px) {
    .modal-content {
      width: 95vw;
      /* padding: 10px; */
    }

    .modal-close {
      font-size: 1.3rem;
    }

    .modal-image {
      max-width: 160px;
      max-height: 160px;
    }
  }
}`, "",{"version":3,"sources":["webpack://./src/catalog/ProductModal.css"],"names":[],"mappings":"AAAA;EACE;IACE,eAAe;IACf,QAAQ;IACR,kCAAkC;IAClC,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,8CAA8C;IAC9C,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,iBAAiB;IACjB,WAAW;IACX,eAAe;IACf,WAAW;EACb;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,aAAa,EAAE,+BAA+B;IAC9C,YAAY;EACd;;EAEA,6BAA6B;EAC7B;IACE,eAAe;IACf,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,aAAa;EACf;;;EAGA,0CAA0C;EAC1C;IACE,SAAO;IACP,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,aAAa;IACb,sBAAsB;EACxB;;EAEA,qBAAqB;EACrB;IACE,UAAU;EACZ;EACA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,QAAQ;EACV;;EAEA;IACE,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,SAAO;EACT;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,kBAAkB;EACpB;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA,2BAA2B;EAC3B;IACE;MACE,YAAY;IACd;EACF;;EAEA;IACE;MACE,eAAe;MACf,gBAAgB;IAClB;;IAEA;MACE,sBAAsB;IACxB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,gBAAgB;MAChB,iBAAiB;IACnB;EACF;;EAEA;IACE;MACE,WAAW;MACX,mBAAmB;IACrB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,gBAAgB;MAChB,iBAAiB;IACnB;EACF;AACF","sourcesContent":[".product-modal {\n  .modal-overlay {\n    position: fixed;\n    inset: 0;\n    background: rgba(30, 32, 38, 0.45);\n    z-index: 1200;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 8px;\n  }\n\n  .modal-content {\n    background: #fff;\n    border-radius: 12px;\n    box-shadow: 0 6px 36px rgba(60, 72, 100, 0.18);\n    width: 700px;\n    max-width: 90vw;\n    max-height: 85vh;\n    display: flex;\n    flex-direction: column;\n  }\n\n  .modal-close {\n    position: absolute;\n    top: 10px;\n    right: 12px;\n    font-size: 1.6rem;\n    color: #444;\n    cursor: pointer;\n    z-index: 10;\n  }\n\n  .modal-body {\n    display: flex;\n    flex-direction: row;\n    width: 100%;\n    min-height: 0; /* Crucial for flex scrolling */\n    height: 100%;\n  }\n\n  /* Left side: Image (Fixed) */\n  .modal-image-col {\n    flex: 0 0 300px;\n    background: #f9f9fb;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 16px;\n    min-height: 0;\n  }\n\n\n  /* Right side: Form Content (Scrollable) */\n  .modal-form-col {\n    flex: 1;\n    padding: 16px;\n    overflow-y: auto;\n    min-height: 0;\n    display: flex;\n    flex-direction: column;\n  }\n\n  /* Custom scrollbar */\n  .modal-form-col::-webkit-scrollbar {\n    width: 6px;\n  }\n  .modal-form-col::-webkit-scrollbar-thumb {\n    background: #ccc;\n    border-radius: 3px;\n  }\n\n  .modal-title {\n    font-size: 1.05rem;\n    font-weight: 700;\n    margin-bottom: 8px;\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 4px;\n  }\n\n  .modal-name {\n    color: #23213b;\n    font-size: 1.05rem;\n  }\n\n  .modal-sku {\n    color: #8882f6;\n    font-size: 0.85rem;\n    margin-left: 6px;\n  }\n\n  .modal-form {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    flex: 1;\n  }\n\n  .modal-label {\n    font-size: 0.85rem;\n    font-weight: 600;\n    color: #444;\n    margin-bottom: 4px;\n  }\n\n  .form-control,\n  .form-select {\n    font-size: 0.75rem;\n  }\n\n  .btn-sm {\n    font-size: 0.7rem;\n    padding: 5px 10px;\n  }\n\n  /* Responsive adjustments */\n  @media (min-width: 1024px) {\n    .modal-content {\n      width: 850px;\n    }\n  }\n  \n  @media (max-width: 768px) {\n    .modal-content {\n      max-width: 95vw;\n      max-height: 90vh;\n    }\n\n    .modal-body {\n      flex-direction: column;\n    }\n\n    .modal-image-col {\n      flex: 0 0 300px;\n    }\n\n    .modal-image {\n      min-width: 180px;\n      min-height: 180px;\n    }\n  }\n\n  @media (max-width: 480px) {\n    .modal-content {\n      width: 95vw;\n      /* padding: 10px; */\n    }\n\n    .modal-close {\n      font-size: 1.3rem;\n    }\n\n    .modal-image {\n      max-width: 160px;\n      max-height: 160px;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
